import {commonCustomFieldTypes} from "mytime-common/custom-fields/custom-field-types";
import React from "react";
import cln from "classnames";
import {renderSingleLineRow} from "./single-line-row/single-line-row";
import {kioskCfUi} from "./kiosk-cf-ui";
import {MonthdayPicker} from "./monthday-picker/monthday-picker";
const {required} = require("mytime-common/forms/required-validator");

const customPaths = {
    "MyClient::CustomField::DateOfBirth"        : ["date_of_birth"],
    "MyClient::CustomField::Gender"             : ["gender"],
    "MyClient::CustomField::MarketingSms"       : ["can_receive_manual_sms"],
    "MyClient::CustomField::MarketingEmail"     : ["can_receive_manual_emails"],
    "MyClient::CustomField::TransactionalSms"   : ["can_receive_automated_sms"],
    "MyClient::CustomField::TransactionalEmail" : ["can_receive_automated_emails"],
};
export const kioskIfiToCf = ({customFields, showErrors, employees, ui, isInternational}) => (ifi) => {
    let customFieldConfig = ifi.custom_field;
    let fieldType = customFieldTypes[customFieldConfig.type];
    if (fieldType == null) {
        console.error(`Unsupported type ${customFieldConfig.type}`)
        // console.log(customFieldConfig.custom_field_options)
        return null;
    }

    const validators = [];
    const isRequired = ifi.required === 1 || ifi.required === 2;
    if (isRequired) {
        // eslint-disable-next-line
        validators.push(fieldType.requiredValidator && {name: "required", validate: fieldType.requiredValidator} || required);
    }

    const data = {
        regex: customFieldConfig.regex,
        content: customFieldConfig.content,
    };
    const validateFormat = fieldType.getFormatValidator?.({data, isInternational});
    if (validateFormat) {
        validators.push({
            name: "format",
            validate: validateFormat,
        });
    }

    let path = customPaths[customFieldConfig.type] || ["custom_field_values", ifi.custom_field_id];



    return {
        path,
        validators,
        subValidators: fieldType.subValidators,
        render: (scopedFv, disabled) => {

            if(customFieldConfig.checked_by_default && scopedFv.value == null) {
                scopedFv.pushValue("1");
            }

            return fieldType.wrap({
                title: customFieldConfig.title,
                key: ifi.id,
                showErrors,

                path: path,
                isRequired,
                hasError: !scopedFv.isValid(),
                error: scopedFv.getError()?.name,

                control: fieldType.renderControl({
                    fv: scopedFv,
                    options: customFieldConfig.custom_field_options,
                    extra: {options: customFieldConfig.options},
                    data,
                    employees,
                    disabled,
                    customFieldConfig,
                    ui: kioskCfUi(ui),
                }),
        })},
    };
};

export const renderFormGroupRow = ({title, key, control, path, hasError, isRequired, showErrors}) => (
    <div className="form-row" key={key} data-path={path.join(".")}>
        <div className={cln("form-group", {"has-error": showErrors && hasError})}>
            <div className="control-label">
                {title}

                {isRequired && "*"}
            </div>

            {control}
        </div>
    </div>
);

export const customFieldTypes = {
    ...commonCustomFieldTypes({
        renderGroup: renderFormGroupRow,
        renderLine: renderSingleLineRow,
    }),

    "MyClient::CustomField::Selection": {
        wrap: renderFormGroupRow,
        renderControl: ({options, disabled, fv, ui}) => {
            return options.map((opt) => (
                renderRadio(opt.id, opt.option_value)({fv, ui})
            ));
        },
    },

    "MyClient::CustomField::DateOfBirth": {
        wrap: renderFormGroupRow,
        renderControl: ({disabled, fv: {value, pushValue}}) => (
            <MonthdayPicker
                value={value && new Date(value)}
                onChange={(date) => pushValue(date?.toISOString())}
                disabled={disabled}
                dataProps={{path: "date_of_birth"}}
            />
        ),
    },
};

const renderRadio = (targetValue, label) => ({fv: {value, pushValue}, ui}) =>  {
    const selected = targetValue === value;

    return (
        <div
            key={targetValue}
            className="radio-line-y324y"
            onClick={() => pushValue(targetValue)}
        >
            <div
                className={cln("radio", {checked: selected})}
                style={selected ? {
                    background: ui.theme_color
                } : {}}
            >
                {selected && (
                    <img alt="checkbox tick" src={require("mytime-common/custom-fields/common/checkbox-tick.svg")}/>
                )}
            </div>
            <div className="label">
                {label}
            </div>
        </div>
    );
};
